const LineDot = props => {
  const { cx, cy, stroke } = props
  return (
    <svg
      x={cx - 5}
      y={cy - 5}
      width={10}
      height={10}
    >
      <circle
        cx='5'
        cy='5'
        r='4'
        stroke='#fff'
        strokeWidth='1'
        fill={stroke}
      />
    </svg>
  )
}

export default LineDot
